var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "self-select-stock"
  }, [_c("section", {
    staticClass: "self-select-stock__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "自选股同步",
      description: "自选股云服务，解决自选股在不同设备间的无缝同步问题； 兼容多设备的同时，智能转换不同市场间的股票代码，兼容第三方自选股服务",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "self-select-stock__introduction-wrapper"
  }, [_c("Introduction")], 1), _c("section", {
    staticClass: "self-select-stock__advantage-wrapper"
  }, [_c("Advantage")], 1), _c("section", {
    staticClass: "self-select-stock__cases-wrapper"
  }, [_c("Cases")], 1), _c("section", {
    staticClass: "self-select-stock__appointment-wrapper"
  }, [_c("Appointment2", {
    staticClass: "stock-appoint",
    attrs: {
      productId: _vm.productId
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };